import React from 'react';
import { UserType } from '../../types';
import UserMentionDescriptionByline from './UserMentionDescriptionByline';
import TeamMentionDescriptionByline from './TeamMentionDescriptionByline';
export default class MentionDescriptionByline extends React.PureComponent {
  render() {
    const {
      userType
    } = this.props.mention;

    switch (userType) {
      case UserType[UserType.TEAM]:
        {
          return /*#__PURE__*/React.createElement(TeamMentionDescriptionByline, {
            mention: this.props.mention
          });
        }

      default:
        {
          return /*#__PURE__*/React.createElement(UserMentionDescriptionByline, {
            mention: this.props.mention
          });
        }
    }
  }

}